"use client";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Link from "next/link";
import blogsData from "../../data/blogs.json";

export default function BlogPage() {
  const blogs = blogsData;

  return (
    <Container className="py-5">
      <h1 className="text-center mb-4 fw-bold">Our Blog</h1>
      <p className="text-center mb-5 text-muted">
        Explore in-depth tutorials, expert insights, and practical tips on AI
        tools, productivity apps, and smart workflows with AIToolPilot — your
        guide to boosting efficiency and creativity online.
      </p>

      <Row xs={1} md={2} lg={3} className="g-4">
        {blogs.map((blog) => (
          <Col key={blog.slug}>
            <Card className="h-100 shadow-sm border-0">
              <div className="ratio ratio-16x9">
                <Card.Img
                  variant="top"
                  src={blog.image}
                  alt={blog.title}
                  className="object-fit-cover"
                />
              </div>

              <Card.Body className="d-flex flex-column">
                <Card.Title>{blog.title}</Card.Title>
                <Card.Text className="grow">{blog.excerpt}</Card.Text>
                <div className="mt-auto">
                  <Link
                    href={`/blog/${blog.slug}`}
                    className="text-decoration-none"
                  >
                    <Button variant="dark" size="sm" as="span">
                      Read More →
                    </Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
